import React from "react";
import { Modal, Button } from "react-bootstrap";
import check from "../../../../assets/check.png";
import "./modal.scss";
import dateFormat from "dateformat";

const BulkRescheduleModal = ({ show, okayClickHandler, fromDate, toDate }) => {
  return (
    <>
      {show ? (
        <Modal show={show} onHide={okayClickHandler} centered>
          <Modal.Body className="py-4 px-2">
            <div className="bulk-reschedule-modal">
              <div className="text-center align-items-center">
                <img
                  src={check}
                  alt="Success"
                  style={{ width: "77px", height: "77px" }}
                />
                <p className="font-weight-bold my-1 modal-heading">
                  All Appointments are Rescheduled
                </p>
                {
                  <p>
                    All appointments for{" "}
                    <b>
                      {fromDate &&
                        dateFormat(new Date(fromDate), "dS mmmm yyyy")}
                    </b>{" "}
                    have been rescheduled to{" "}
                    <b>
                      {toDate && dateFormat(new Date(toDate), "dS mmmm  yyyy")}
                    </b>
                  </p>
                }
              </div>
              <div className="d-flex flex-column justify-content-center align-items-center">
                <Button
                  className="border-0 rounded-pill "
                  style={{
                    backgroundColor: "#17BAE0",
                    color: "#fff",
                    width: "140px",
                    height: "44px",
                  }}
                  onClick={okayClickHandler}
                >
                  Okay
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      ) : null}
    </>
  );
};

export default BulkRescheduleModal;
